import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config/config';
import styles from './AdminsComp.module.css'
const AdminsComp = () => {

    const [admins, setAdmins] = useState([]);

  const fetchAdmins = async () => {
    try {
      const res = await axios.get(`${config.apiBaseUrl}/api/admin/all`);
      setAdmins(res.data);
    } catch (err) {
      console.error('Error fetching admins:', err);
    }
  };

  const deleteAdmin = async (id) => {
    try {
      await axios.delete(`${config.apiBaseUrl}/api/admin/${id}`);
      setAdmins(prev => prev.filter(admin => admin._id !== id));
    } catch (err) {
      console.error('Error deleting admin:', err);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <div>
        <div className={styles.siteAdminsMain}>
                <h1 className={styles.siteAdminsTitle}>Site Administrators</h1>
                
                {admins.length > 0 ? (
                  <table className={styles.siteAdminsTable}>
                    <thead className={styles.siteAdminsTableHeader}>
                      <tr>
                        <th>Full Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admins.map(admin => (
                        <tr key={admin._id} className={styles.siteAdminsTableRow}>
                          <td className={styles.siteAdminsTableCell} data-label="Full Name">
                            {admin.fullname}
                          </td>
                          <td className={styles.siteAdminsTableCell} data-label="Email">
                            {admin.email}
                          </td>
                          <td className={styles.siteAdminsTableCell} data-label="Role">
                            {admin.role || 'Administrator'}
                          </td>
                          <td className={styles.siteAdminsTableCell} data-label="Actions">
                            <button 
                              className={styles.siteAdminsActionBtn}
                              onClick={() => deleteAdmin(admin._id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className={styles.siteAdminsEmptyState}>
                    No administrators found
                  </div>
                )}
              </div>
    </div>
  )
}

export default AdminsComp